import { CF_PROPORTIONS_DICTIONARY } from "../constants";
import { CfDoubleContentProps } from "../types";
import {
  convertCfAlignItemsProps,
  convertCfJustifyContentProps,
} from "utilities/cfPropTypes/cfFlex";
import { convertCfBackgroundProps } from "utilities/cfPropTypes/cfBackground";
import { convertCfColOrderProps } from "utilities/cfPropTypes/cfColOrder";
import { convertCfSpacersProps } from "utilities/cfPropTypes/cfSpacers";
import { convertCfWrapContentProps } from "utilities/cfPropTypes/cfWrapContent";
import DoubleContent from "../index";
import React from "react";

export const convertCfDoubleContentProps = ({
  doubleContentStyle,
  order,
  proportions,
  slug,
  wrapContent,
  children,
}: CfDoubleContentProps) => ({
  proportions:
    proportions !== "" ? CF_PROPORTIONS_DICTIONARY?.[proportions] : "6:6",
  slug,
  children,
  ...convertCfBackgroundProps(doubleContentStyle?.background),
  ...convertCfAlignItemsProps(doubleContentStyle?.alignItems),
  ...convertCfJustifyContentProps(doubleContentStyle?.justifyContent),
  ...convertCfSpacersProps(doubleContentStyle?.spacers),
  ...convertCfColOrderProps(order),
  ...convertCfWrapContentProps(wrapContent),
});

const CfDoubleContent = (props: CfDoubleContentProps) => (
  <DoubleContent {...convertCfDoubleContentProps(props)} />
);

export default CfDoubleContent;
